import React from 'react'

//import styles from './Label.module.css'

const WarrantsLabel = ({
  ai: {
    attributes: { USER_Name },
  },
}) => (
  <div>
    <div>{USER_Name || ['[BLANK]']}</div>
  </div>
)

export default WarrantsLabel
